import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Video.scss'


class Video extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    playerClassName: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    preview: PropTypes.string,
    isSquare: PropTypes.bool,
    autoPlay: PropTypes.bool,
    handleVideoRef: PropTypes.func,
    testId: PropTypes.string,
    videoProps: PropTypes.object,
  }

  setNode = (el) => {
    this.node = el
  }

  render() {
    const {
      id, className, playerClassName, type, preview, isSquare, autoPlay, handleVideoRef, videoProps, testId,
    } = this.props
    let {url} = this.props

    const videoContainerClassName = cx(s.videoContainer, className, {
      [s.square]: isSquare,
    })

    if (/youtu\.be/.test(url)) {
      url = url.replace('youtu.be', 'www.youtube.com/embed')
    }
    if (type === 'youtube' && autoPlay) {
      const hasQuery = /\?[^?]+$/.test(url)

      url = `${url}${hasQuery ? '&' : '?'}autoplay=1`
    }

    return (
      <div className={videoContainerClassName}>
        {/*<div className={s.overlay}>*/}
          {/*<div className={s.triangle}/>*/}
        {/*</div>*/}
        {
          type === 'youtube' && (
            <iframe
              className={cx(s.video, playerClassName)}
              id={id}
              src={url}
              title="youtube video"
              frameBorder="0"
              allowFullScreen
              data-testid={testId}
              ref={this.setNode}
            />
          )
        }
        {
          type === 'mp4' && (
            <video
              className={cx(s.video, playerClassName)}
              id={id}
              poster={preview}
              ref={this.setNode}
              autoPlay={autoPlay}
              controls
              data-testid={testId}
              {...videoProps}
            >
              <source src={url} type="video/mp4"/>
            </video>
          )
        }
      </div>
    )
  }
}


export default Video
